import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { Dialog as EvergreenDialog } from 'evergreen-ui'
import PropTypes from 'prop-types'

import Txt from '../Txt'
import Icon from '../Icons'
import ButtonComponent from '../Button'
import { useTheme } from '../../theming/ThemeProvider'

export default function Dialog (props) {
  const {
    open,
    children,
    title,
    action,
    loading,
    onAction,
    onClose
  } = props

  const { theme } = useTheme()
  const styles = useStyles(theme)

  return (
    <EvergreenDialog
      isShown={open}
      onCancel={onClose}
      onCloseComplete={onClose}
      hasFooter={false}
      hasHeader={false}
      containerProps={{
        style: {
          margin: 'auto'
        }
      }}
      title={title}
    >
      <View
        style={styles.container}
        testID='WebDialogContainer'
      >
        <View style={styles.header}>
          <Txt
            text={title}
            identity='subtitleBold'
          />
          <TouchableOpacity activeOpacity={0.8} onPress={onClose}>
            <Icon
              name='Exit'
              width={10}
              height={10}
            />
          </TouchableOpacity>
        </View>
        {children}
        <View style={styles.footer}>
          <View
            style={{
              marginRight: action ? 10 : 0
            }}
          >
            <ButtonComponent
              title='Cancel'
              onPress={onClose}
            />
          </View>
          {Boolean(action) && (
            <View style={styles.acceptButton}>
              <ButtonComponent
                title={action}
                loading={loading}
                onPress={onAction}
              />
            </View>
          )}
        </View>
      </View>
    </EvergreenDialog>
  )
}

const useStyles = (theme) => StyleSheet.create({
  modal: {
    margin: 'auto'
  },
  fullViewModal: {
    width: '100%',
    height: '100%'
  },
  container: {
    marginHorizontal: 20,
    backgroundColor: theme.WHITE,
    overflow: 'hidden'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 20
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    marginVertical: 20
  },
  acceptButton: {
    marginLeft: 10
  }
})

Dialog.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.any,
  title: PropTypes.string,
  action: PropTypes.string,
  onAction: PropTypes.func,
  onClose: PropTypes.func,
  loading: PropTypes.bool
}

Dialog.defaultProps = {
  open: false,
  children: null,
  title: '',
  action: '',
  onAction: () => {},
  onClose: () => {},
  loading: false
}
